<!--  -->
<template>
  <div class="GoBack">
    <div class="back" @click="goback">
      <img src="https://oss.sbooip.com/static/www/pc/assets/images/back.png" alt=""  >
      <div>返回上一页</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoBack",
  components: {},
  data() {
      return {

      };
  },
  methods: {
    goback(){
      window.history.back()
    }
  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.back{
  text-align: center;
  position: fixed;
  left: 40px;
  bottom: 200px;
  cursor: pointer;
  img{
    width: 40px;
    opacity: 0.7;
  }
  div{
    text-align: center;
    color: #494848;
  }
  background-color: #dbdada;
  padding: 10px;
  border-radius: 8px;
  z-index: 999999999;
}
</style>